import { Spinner } from "@marekl/adminer/components";
import styles from "./ForceRefreshOverlay.module.css";

/**
 * Full-screen blocking overlay shown while a forced refresh is pending
 * (the running frontend build is outdated — see useForcedRefresh). It
 * intentionally has no close button, ESC handling, or backdrop click:
 * the user must not perform any further action; the page reloads itself.
 * This is the one sanctioned exception to the "use the shared Modal"
 * rule, precisely because Modal is dismissible by design.
 */
export function ForceRefreshOverlay() {
  return (
    <div className={styles.overlay} role="alert">
      <div className={styles.card}>
        <Spinner size="lg" ariaLabel="Načítání" />
        <h2 className={styles.title}>Aplikace byla aktualizována</h2>
        <p className={styles.text}>Stránka se nyní automaticky obnoví…</p>
      </div>
    </div>
  );
}
